export default __webpack_public_path__ + "static/media/ChandrakantJadhav.563887a3.png";